import apiClient from "./config";

const productService = {
  // Get all products
  getAllProducts: async () => {
    try {
      const response = await apiClient.get("/products");
      console.log("getAllProducts response:", response.data);
      return response.data.products || [];
    } catch (error) {
      console.error(
        "Error in getAllProducts:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  },

  // Get product by ID
  getProductById: async (productId) => {
    try {
      console.log("Fetching product with ID:", productId);
      const response = await apiClient.get(`/products/${productId}`);
      console.log("getProductById response:", response.data);
      if (!response.data.product) {
        throw new Error("Product not found");
      }
      return response.data.product;
    } catch (error) {
      console.error(
        "Error in getProductById:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch product details"
      );
    }
  },

  // Create new product
  createProduct: async (productData) => {
    try {
      console.log("Creating product with data:", productData);
      const response = await apiClient.post("/products", productData);
      console.log("createProduct response:", response.data);
      return response.data.product;
    } catch (error) {
      console.error(
        "Error in createProduct:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to create product"
      );
    }
  },

  // Update product
  updateProduct: async (productId, productData) => {
    try {
      console.log("Updating product:", productId, "with data:", productData);
      const response = await apiClient.put(
        `/products/${productId}`,
        productData
      );
      console.log("updateProduct response:", response.data);
      return response.data.product;
    } catch (error) {
      console.error(
        "Error in updateProduct:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to update product"
      );
    }
  },

  // Delete product
  deleteProduct: async (productId) => {
    try {
      console.log("Deleting product:", productId);
      const response = await apiClient.delete(`/products/${productId}`);
      console.log("deleteProduct response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error in deleteProduct:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to delete product"
      );
    }
  },
};

export default productService;
